import React, {Component} from "react"
import Spinner from './Spinner'
import Alert from './Alert'
import ErrorAlert from './ErrorAlert'

class ComponentWrapper extends Component {
  render() {
    return (
      <div>
        <Spinner show={this.props.loading}/>
        <ErrorAlert error={this.props.error}/>
        <Alert show={this.props.message} message={this.props.message}/>
        {(!this.props.loading && !this.props.error)?this.props.children:""}
      </div>
    )
  }
}

export default ComponentWrapper



// WEBPACK FOOTER //
// ./src/components/ComponentWrapper.js